// extracted by mini-css-extract-plugin
export default {"form":"PQAPD","errorText":"IppI6","actions":"bDjDG","action":"Vm_7o","courseItem":"Kqcyb"};